import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslations } from "../../providers/useTranslations";
import { FormattedPrice } from "../FormattedPrice";
export const Price = ({ price, frequency, frequencySeparator = "/", frequencyClassName, className, }) => {
    const { __ } = useTranslations();
    const { currency, value } = price;
    return (_jsxs("div", { className: className, children: [value === -1 ? __("libs.ui.price.na") : _jsx(FormattedPrice, { value: value, currency: currency }), frequency ? (_jsxs("span", { className: frequencyClassName, children: [frequencySeparator, frequency] })) : null] }));
};
//# sourceMappingURL=Price.js.map